import { template } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ControlTower from 'wise-control-tower';
import { task } from 'ember-concurrency';
import { eq } from 'ember-truth-helpers';
import WrForm from 'ember-wiser/components/wr/form';
import { Changeset } from 'ember-changeset';
import perform from 'ember-concurrency/helpers/perform';
interface Model {
    sendTo?: string;
}
export default class PatientWebRequestAccessTokenComponent extends Component {
    // how does the patient want to receive the login link
    @tracked
    sendBy;
    get sendTo() {
        return this.model.sendTo as string;
    }
    // The successful submit server response
    @tracked
    successfulResponse;
    // The error returned by the submit call, if any
    @tracked
    error;
    @service
    requestManager;
    model = Changeset({
        sendTo: ''
    }) as Model;
    submitTask = task(async ()=>{
        this._reset();
        // Remove any whitespace within phone or email value
        const inputValue1 = (this.sendTo as string).replace(/\s/g, '');
        //if value is composed only of numbers or starting by + and followed by numbers (handle +33 phone numbers)
        if (inputValue1.match(/^\+?(\d)+$/)) {
            this.sendBy = 'SMS';
        } else {
            this.sendBy = 'email';
        }
        const data1 = JSON.stringify({
            send_by: this.sendBy,
            send_to: this.sendTo
        });
        try {
            const { response: response1, content: content1 } = await this.requestManager.request({
                url: '/api/v1/patient_token',
                method: 'POST',
                body: data1
            });
            if (!response1.ok) throw response1;
            this.successfulResponse = content1;
        } catch (e1) {
            this.error = e1;
            /* Only the 404 error is valid for display. It means the patient has not been found. */ if (e1.status == 404) return;
            ControlTower.captureException(e1);
        }
    });
    _reset() {
        this.successfulResponse = undefined;
        this.error = undefined;
    }
    static{
        template(`
    {{#if this.successfulResponse}}
      <div class='ui positive message'>
        Un lien de connexion va vous être envoyé par
        {{this.sendBy}}.
      </div>
    {{else}}
      {{#if this.error}}
        <div class='ui negative message'>
          {{#if (eq this.error.status 404)}}
            Aucun compte n'existe avec
            {{if
              (eq this.sendBy 'email')
              'cet email'
              'ce numéro de téléphone'
            }}.
          {{else}}
            {{! Any other error }}
            Nous sommes désolés, une erreur est survenue.
          {{/if}}
        </div>
      {{/if}}

      <WrForm
        @data={{this.model}}
        @onSubmit={{perform this.submitTask}}
        class='flex w-full max-w-[355px] flex-col items-center gap-6'
        as |form|
      >
        {{#unless this.successfulResponse}}
          <form.Input
            @name='sendTo'
            aria-label='Votre e-mail ou numéro de téléphone'
            type='text'
            required={{true}}
            placeholder='Votre e-mail ou numéro de téléphone'
            data-test-login='email-or-phone'
          />
        {{/unless}}

        <form.SubmitButton @icon='ArrowRight'>
          Recevoir le lien
        </form.SubmitButton>
      </WrForm>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
